module.exports = {"moreInfo":[{"pageName":"gatwick-parking-reviews/long-stay-gatwick-reviews","pageTitle":"Reviews for Long Stay North Gatwick - Airparks","description":"Official Gatwick Parking at the Long Stay car park just a 5 minute transfer from the North Terminal. See what Airparks customers think about this Gatwick Airport car park."}],"moreInfoText":[]}


//////////////////
// WEBPACK FOOTER
// ./config/exports/moreInfo/parking/LGW.json
// module id = 355
// module chunks = 119